import weapons from '../../data/weapons'
import Weapon from '../../models/Weapon'

// initial state
const state = () => ({

})

// getters
const getters = {
    all: () => {
        return Weapon.query().all();
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', weapons)
    }
}

// mutations
const mutations = {
    load(state, weapons) {
        Weapon.create({
            data: weapons
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}